<template>
  <div :id="$style.overview">
    <Header />
    <h1>Overview</h1>
    <div :class="$style.body">
      <div :class="[$style.block]">
        <h2>Auto upgrade disabled</h2>
        <button v-on:click="loadAutoUpgrade()">Load list</button>
        <div v-show="loading">Loading...</div>
        <div v-for="user in userList">
          <router-link :to="/users/ + user.id">{{user.email}}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../lib/Header'
  import database from '../../database'

  export default {
    name: 'Overview',
    components: {
      Header
    },
    data () {
      return {
        loading: false,
        userList: {}
      }
    },
    methods: {
      loadAutoUpgrade () {
        this.loading = true
        database.getWhile(['accounts'], 'disableAutoUpgrade', true)
          .then(data => {
            this.userList = data
            this.loading = false
          })
      }
    }
  }
</script>

<style lang="scss" module>
  #overview {
    .body {
      display: flex;
      align-items: flex-start;

      .block {
        flex-grow: 3;
        margin-top: 30px;
        padding: 20px 20px 40px;
        background-color: white;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
        box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);

        &:first-child {
          margin-right: 10px;
        }

        &.short {
          max-width: 400px;
          flex-grow: 1;
        }
      }
      a {
        display: inline-block;
        padding: 10px 0;
        line-height: 1em;
        color: rgb(0, 0, 0);
        text-decoration: none;

        &:hover {
          background-color: rgba(white, 0.05);
          color: rgb(113, 126, 131);;
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Overview/index.vue